import orderBy from 'lodash/orderBy'

import { ConfiguredColumn } from '../../../types'

export const sortByOrder = (array: ConfiguredColumn[]) => {
  return orderBy(array, ['restrictions.order'], ['asc'])
}
